import DialogTitle from '@mui/material/DialogTitle'
import Dialog from '@mui/material/Dialog'
import CloseIcon from '@mui/icons-material/Close'
import { DialogActions, DialogContent, IconButton } from '@mui/material'

import './style.css'
import iconReject from '../../../icons/iconReject.svg'


export const DialogConfirmDelete = ({ open, setOpen, params }) => {

    const { text_title, text_confirm, button_name, handleDelete } = params

    return (
        <Dialog onClose={() => setOpen(false)} open={open} className='p-dialog-approve'>
            <DialogTitle className='ColorTitleDocument' id="scroll-dialog-title">
                <IconButton
                    aria-label="close"
                    style={{ padding: '0', float: 'right' }}
                    onClick={() => setOpen(false)}
                >
                    <CloseIcon
                        style={{ color: '#78667E' }}
                    />
                </IconButton>
            </DialogTitle>
            <DialogContent className='content'>
                <div className='d-flex justify-content-center p-icons'>
                    <img src={iconReject} alt="icon confirm" />
                </div>
                <div className='text'>
                    <h3>{text_title || 'Confirmación de eliminación'}</h3>
                    <p>{text_confirm || '¿ Está seguro/a de realizar esta acción?'}</p>
                </div>
            </DialogContent>
            <DialogActions className='d-flex justify-content-center mt-3 mb-2 p-actions'>
                <button className='approve' onClick={handleDelete}>{button_name || 'Sí, eliminar'}</button>
            </DialogActions>
        </Dialog>
    );

}